"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitted = exports.processsingEmission = exports.pendingEmission = exports.pendingInspection = exports.withVehicleRCPackProduct = exports.withVehicleRCProduct = exports.withVehicleProduct = void 0;
var QuotationSummaryResponse_1 = require("../models/QuotationSummaryResponse");
var mockQuotationStatus = __importStar(require("./mockQuotationStatus"));
var products_1 = require("../constants/products");
/**
 * The base summary
 */
var baseSummary = __assign(__assign({}, QuotationSummaryResponse_1.makeEmptyQuotationSummary()), { status: {
        id: 2,
        code: 'code',
        name: 'name',
    }, customerName: 'Customer Name', carBrand: 'mock-brand', carModel: 'mock-model', carYear: '1000', quotationDate: '12/12/2020', anualPayment: 1000, insuranceValue: 999, description: 'Cobertura completa', productType: 'Vehicle' });
/**
 * Possible product configurations
 */
exports.withVehicleProduct = __assign(__assign({}, baseSummary), { productType: products_1.COMPLETE_VEHICLE });
exports.withVehicleRCProduct = __assign(__assign({}, baseSummary), { productType: products_1.THIRD_PARTY_VEHICLE });
exports.withVehicleRCPackProduct = __assign(__assign({}, baseSummary), { productType: products_1.THIRD_PARTY_PACK });
/**
 * Possible status configurations
 */
exports.pendingInspection = __assign(__assign({}, baseSummary), { status: mockQuotationStatus.pendingInspection });
exports.pendingEmission = __assign(__assign({}, baseSummary), { status: mockQuotationStatus.pendingEmission });
exports.processsingEmission = __assign(__assign({}, baseSummary), { status: mockQuotationStatus.processingEmission });
exports.emitted = __assign(__assign({}, baseSummary), { status: mockQuotationStatus.emitted });
//# sourceMappingURL=mockQuotationSummaries.js.map